import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Screenshot,
  Section,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const RiskRegister = () => (
  <Page
    title="Risk Register"
    intro="The risk register tracks organisational risks scored by likelihood and consequence, with a red/amber/green (RAG) rating."
  >
    <Section title="Using the register">
      <Bullets>
        <Bullet>
          Open <DocLink url="/risk-register" text="Risk Register" /> to see
          logged risks and their current ratings.
        </Bullet>
        <Bullet>
          Add a risk with a category (Clinical, Operational, or Corporate) and
          an initial likelihood and consequence rating - the risk score is
          likelihood multiplied by consequence, colour-coded RAG.
        </Bullet>
        <Bullet>
          Open an individual risk to record its mitigation, update the current
          likelihood and consequence as controls take effect, set a target
          rating, and keep a comment thread. Initial, current, and target
          scores are shown side by side.
        </Bullet>
        <Bullet>
          Follow-up work arising from a risk can be tracked as a governance
          action alongside actions from audits, incidents, and the CQC Centre
          - see{' '}
          <DocLink
            docsPage
            url="/clinical-governance/governance-actions"
            text="Governance Actions"
          />
          .
        </Bullet>
      </Bullets>
      <Screenshot url="governance/risk-register.png">
        The Risk Register with each risk's category and RAG-rated likelihood,
        consequence, and score.
      </Screenshot>
      <Info title="Who can do this?">
        Creating, editing, deleting, listing, and commenting on risks requires
        the Governance team (site administrators always have access). The risk
        register is a tier 2 feature.
      </Info>
    </Section>
    <Section title="CQC Centre integration">
      <Bullets>
        <Bullet>
          Each risk can be linked to a CQC regulated activity (TDDI or
          transport, triage and medical advice) and to one or more CQC quality
          statements - set these when adding a risk or from the CQC Centre card
          on the risk page.
        </Bullet>
        <Bullet>
          Linked risks appear as evidence against the chosen statements in the{' '}
          <DocLink
            docsPage
            url="/clinical-governance/cqc-centre-overview"
            text="CQC Centre"
          />{' '}
          and in the Risk Register section of the Inspection Pack. Risks with no
          statements selected use the default mapping: Safe (involving people
          to manage risks) and Responsive (planning for the future).
        </Bullet>
        <Bullet>
          Reviews feed the CQC readiness score: posting a progress comment or
          pressing "Mark Reviewed" updates the review date. Every risk is on
          an annual review cycle - a risk not reviewed for over a year raises
          a gap in the CQC Centre (a brand-new risk's year runs from the date
          it was added). For risks with a current score of 8 or more the gap
          is raised at Critical severity; for others it is Important.
        </Bullet>
      </Bullets>
    </Section>
  </Page>
)

export default RiskRegister
